import { render } from "./ReplaceView.vue?vue&type=template&id=0c88b997"
import script from "./ReplaceView.vue?vue&type=script&lang=js"
export * from "./ReplaceView.vue?vue&type=script&lang=js"
script.render = render

export default script